import React from "react";
import DisplayOnViewportIntersection from "@/bit/components/next13.components.display-on-viewport-intersection";
import GridLayout from "./layouts/grid-layout";
import InlineLayout from "./layouts/inline-layout";
import StyledImageCluserInfo from "./styles";

const ImageClusterInfo = (props) => {
  const modules = Object.keys(props)
    .filter((key) => key.includes("Module"))
    .map((key) => props[key]);

  return (
    <DisplayOnViewportIntersection>
      <StyledImageCluserInfo>
        {modules.map((layoutProps, i) => {
          if (!layoutProps) return null;
          if (layoutProps?.layout === "grid") {
            return <GridLayout {...layoutProps} key={`module-${i}`} />;
          }
          return <InlineLayout {...layoutProps} key={`module-${i}`} />;
        })}
      </StyledImageCluserInfo>
    </DisplayOnViewportIntersection>
  );
};

export default ImageClusterInfo;
